export default "__VITE_PUBLIC_ASSET__e3936b0c__"